import { z } from "zod";
import { shippingAddressSchema } from "./checkout.js";

export const devLoginRequestSchema = z.strictObject({ account: z.enum(["A", "B"]) });
export const wechatLoginRequestSchema = z.strictObject({ code: z.string().min(1).max(512) });
export const customerAccountSchema = z.object({
  id: z.uuid(),
  displayName: z.string().min(1).max(64),
  identityProvider: z.enum(["development", "wechat"]),
});
export const customerSessionSchema = z.object({
  token: z.string().min(32).max(128),
  expiresAt: z.iso.datetime({ precision: 3 }),
  account: customerAccountSchema,
});
export const authCapabilitiesSchema = z.object({
  devLoginEnabled: z.boolean(),
  wechatLoginEnabled: z.boolean(),
});
export const customerAddressResponseSchema = z.object({
  address: shippingAddressSchema.nullable(),
});
export type DevLoginRequest = z.infer<typeof devLoginRequestSchema>;
export type WechatLoginRequest = z.infer<typeof wechatLoginRequestSchema>;
export type CustomerAccount = z.infer<typeof customerAccountSchema>;
export type CustomerSession = z.infer<typeof customerSessionSchema>;
export type CustomerAddressResponse = z.infer<typeof customerAddressResponseSchema>;
